import Abstract from './abstract';
import {GIGYA_READY} from '../constants';
import $ from 'jquery';

const CONTAINER = '[data-voc-pw-concurrent-session]';

class MultiSession extends Abstract {
  constructor() {
    super(CONTAINER, ...arguments);
    this.priority   = -4;
    this.final      = true;
  }

  show() {
    const container$ = $(CONTAINER);

    if (container$.length && container$.is(':visible') && this.concurrentSessionLimit()) {
      container$.show();
      Abstract.canNotViewContent();
      this._logout();
    }
  }

  _logout() {
    Voonto.getInstance().when(GIGYA_READY).then((gigyaux) => gigyaux.logout({reloadOnLogout: false}));
  }
}

export default MultiSession;



// WEBPACK FOOTER //
// ./src/alerts/multi-session.js